import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Title3Props = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold';
};

export const Title3: React.FC<Title3Props> = ({
  children,
  weight = 'regular',
  style,
  ...props
}) => {
  return (
    <RNText style={[s.common, s.title3, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
